export default __webpack_public_path__ + "static/media/astro.9d493722.png";